import React from "react";
import { Navigation, ArrowRight } from "lucide-react";

// Grande carte « course / trajet à venir » en haut de l'accueil conducteur (proposition B).
export default function PinnedTripCard({ kicker, title, from, to, meta, action, onClick, testid }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="street-press mt-5 w-full rounded-3xl bg-primary p-5 text-left text-primary-foreground street-border street-shadow animate-in fade-in slide-in-from-top-2 duration-300"
      data-testid={testid}
    >
      <div className="flex items-center gap-2">
        <span className="relative grid h-9 w-9 place-items-center rounded-xl bg-white street-border-thin">
          <span className="absolute inset-0 rounded-xl bg-white/70 animate-ping-slow" />
          <Navigation className="relative h-4 w-4 text-primary" strokeWidth={2.75} />
        </span>
        <span className="text-[12px] font-black uppercase tracking-widest">{kicker}</span>
      </div>
      <div className="mt-3 font-[Outfit] text-[22px] font-black leading-tight">{title}</div>
      <div className="mt-2 rounded-2xl bg-white/15 px-3 py-2 text-[13px] font-bold">
        <span className="block truncate">{from}</span>
        <span className="block truncate opacity-90">→ {to}</span>
      </div>
      <div className="mt-3 flex items-center justify-between gap-2">
        <span className="truncate text-[12px] font-bold text-primary-foreground/90">{meta}</span>
        <span className="inline-flex flex-none items-center gap-1 rounded-full bg-white px-3.5 py-2 text-[12px] font-black text-foreground street-border-thin">
          {action}<ArrowRight className="h-3.5 w-3.5" strokeWidth={3} />
        </span>
      </div>
    </button>
  );
}
